import { Editor, Transforms, Node } from 'slate';
import { ReactEditor } from 'slate-react';
import shortid from 'shortid';

const withHeadings = editor => {
	const { insertBreak } = editor;

	// Heading elements
	const HEADINGS = ['heading-one', 'heading-two', 'heading-three'];

	// Handle's break event inside table
	// @args: default arguments
	editor.insertBreak = (args) => {
		// Proceed with default break insert if not in heading
		if (!editor.isInHeading()) return insertBreak(args);

		// Split heading
		Transforms.splitNodes(editor, { always: true });

		// Set splitted block to paragraph
		Transforms.setNodes(editor, { type: 'paragraph' });
	};


	// Check if selection is inside heading
	// @format: string | heading's type
	editor.isInHeading = format => {
		const [match] = Editor.nodes(editor, {
			match: node => format
				? node.type === format
				: HEADINGS.includes(node.type)
		});
		return !!match;
	};

	// Toggle given heading on selection
	editor.toggleHeading = type => {
		// Reset heading if active
		if (editor.isElementActive(type)) {
			return Transforms.setNodes(editor, {
				id: null,
				type: 'paragraph'
			});
		}

		// Update heading style if active
		if (editor.isInHeading()) {
			return Transforms.setNodes(editor, {
				type
			});
		}

		// Get current paragraph
		const [element, path] = Editor.above(editor, {
			match: node => node.type === 'paragraph',
		}) ?? [];

		// Remove current paragraph
		Transforms.removeNodes(editor, {
			at: path,
		});

		// Insert node in paragraph's place
		Transforms.insertNodes(editor, {
			id: shortid.generate(),
			type: type,
			children: [{
				text: Node.string(element)
			}]
		}, {
			at: path
		});

		// Update selection
		Transforms.select(editor, path);

		// Collapse current selection
		Transforms.collapse(editor, {
			edge: 'end'
		});

		// Refocus after change
		ReactEditor.focus(editor);
	};

	return editor;
};

export default withHeadings;
